import { useEffect, useRef, useState } from 'react'
import { auroraStore } from '../../store/auroraStore'

/**
 * The typed fallback.
 *
 * Reachable deliberately (the pencil) or automatically when voice is
 * unavailable. Same optimistic path — there is no second-class capture.
 */
export function TextCapture({
  childId, blockId, initial, onClose,
}: {
  childId: string
  blockId?: string
  initial?: string
  onClose: () => void
}) {
  const [text, setText] = useState(initial ?? '')
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => { ref.current?.focus() }, [])

  const submit = () => {
    const trimmed = text.trim()
    if (trimmed) {
      (auroraStore.getState() as any).logTextCapture({ childId, text: trimmed, blockRef: blockId })
    }
    onClose()
  }

  return (
    <div className="capture-scrim" onClick={onClose} role="presentation">
      <div
        className="capture-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Write a note"
      >
        <textarea
          ref={ref}
          className="capture-textarea"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') onClose()
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit()
          }}
          placeholder="How did it go?"
          rows={4}
        />
        <div className="capture-panel-actions">
          <button className="btn btn-quiet btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary btn-sm" onClick={submit} disabled={!text.trim()}>
            Save
          </button>
        </div>
      </div>
    </div>
  )
}
